import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export default function CookieConsent() {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie_consent")) setShow(true);
  }, []);

  const decide = (val) => {
    localStorage.setItem("cookie_consent", val);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-4" data-testid="cookie-consent">
      <div className="max-w-4xl mx-auto bg-white border border-stone-200 shadow-xl rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm text-stone-700 flex-1 leading-relaxed">
          {t.cookie.text}{" "}
          <Link to="/privatlivspolitik" className="underline text-[#1E3A2F] font-medium">{t.footer.privacy}</Link>
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            onClick={() => decide("necessary")}
            className="px-4 py-2.5 rounded-full text-sm font-semibold text-stone-700 border border-stone-300 hover:bg-stone-50"
            data-testid="cookie-necessary-btn"
          >
            {t.cookie.necessary}
          </button>
          <button
            onClick={() => decide("all")}
            className="px-4 py-2.5 rounded-full text-sm font-semibold bg-[#1E3A2F] text-white hover:bg-[#162D24]"
            data-testid="cookie-accept-btn"
          >
            {t.cookie.accept}
          </button>
        </div>
      </div>
    </div>
  );
}
